const Index = () => import('./index.vue');

export default [
    {
        path: '/test-printer',
        component: Index
    }
];